export class GmailMessage {

    constructor(
        public sendTo: string[],
        public subject: string,
        public body: string,
        public formData?: FormData
    ){}
}
